import { Inject, Injectable } from '@angular/core';
import { Environment, ENVIRONMENT } from '@environment';
import { ChannelService } from '@usheru-hff/sdk/channel';

@Injectable({
  providedIn: 'root'
})
export class CommunityElementsService {
  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    private channelService: ChannelService
  ) {}

  isFeatureEnabled(feature: FeatureType): boolean {
    switch (feature) {
      case 'wishlist':
        return this.isWishlistEnabled();
      case 'watched':
        return this.isWatchedEnabled();
      case 'rating':
        return this.isRatingEnabled();
      case 'lists':
        return this.isListsEnabled();
      case 'avatar':
        return this.isAvatarEnabled();
      case 'displayName':
        return this.isDisplayNameEnabled();
    }
  }

  private isWishlistEnabled(): boolean {
    return true;
  }
  private isWatchedEnabled(): boolean {
    return true;
  }
  private isRatingEnabled(): boolean {
    if (this.env.communityConfig?.profileConfig?.rating === undefined) return true;
    return this.env.communityConfig?.profileConfig?.rating;
  }
  private isListsEnabled(): boolean {
    return true;
  }
  private isAvatarEnabled(): boolean {
    if (this.env.communityConfig?.profileConfig?.avatar === undefined) return true;
    return this.env.communityConfig?.profileConfig?.avatar;
  }
  private isDisplayNameEnabled(): boolean {
    if (this.env.communityConfig?.profileConfig?.displayName === undefined) return true;
    return this.env.communityConfig?.profileConfig?.displayName;
  }
}

type FeatureType = 'wishlist' | 'watched' | 'rating' | 'lists' | 'avatar' | 'displayName' | 'followers';
